export default function saleCopyPromocode() {
  return {
    event: 'sales_page_copy_promocode',
  }
}
